var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    { staticClass: "card-holder", attrs: { md: 8, lg: 6, xl: 4 } },
    [
      _c(
        "div",
        { on: { click: _vm.onClick } },
        [
          !_vm.isNewProject
            ? _c(
                "el-card",
                {
                  staticClass: "card-inner card-project",
                  attrs: { shadow: "always" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "card-toolbar" },
                    [
                      _c("div", { staticClass: "card-title" }, [
                        _vm._v(_vm._s(_vm.title))
                      ]),
                      _c(
                        "el-dropdown",
                        {
                          staticClass: "outline",
                          attrs: { trigger: "click" },
                          on: {
                            command: _vm.handleCommand,
                            "visible-change": _vm.visibleChange
                          }
                        },
                        [
                          _c("span", { staticClass: "el-dropdown-link" }, [
                            _c("div", { staticClass: "menu-button" }, [
                              _c(
                                "i",
                                {
                                  staticClass: "material-icons more-icon",
                                  class: { rotate: _vm.isDropdownOpen }
                                },
                                [_vm._v("expand_more")]
                              )
                            ])
                          ]),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  staticClass: "flex",
                                  attrs: { command: "onEdit" }
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("edit")
                                  ]),
                                  _c("span", [_vm._v("Editar painel")])
                                ]
                              ),
                              _vm.isMyProject
                                ? _c(
                                    "el-dropdown-item",
                                    {
                                      staticClass: "flex",
                                      attrs: { command: "onDelete" }
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("delete")]
                                      ),
                                      _c("span", [_vm._v("Excluir painel")])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "card-body" }, [
                    _vm._v(_vm._s(_vm.description))
                  ])
                ]
              )
            : _c(
                "el-card",
                {
                  staticClass: "card-inner card-new-project",
                  attrs: { shadow: "always" }
                },
                [
                  _c("span", { staticClass: "card-content" }, [
                    _c("i", { staticClass: "material-icons card-add" }, [
                      _vm._v("add")
                    ]),
                    _c("span", [_vm._v("Criar novo painel")])
                  ])
                ]
              )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-97adf3d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97adf3d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/demandas/components/Card.vue
// module id = null
// module chunks = 